import { useReducer } from 'react';

import { useSelector } from 'react-redux';
import { selectUserCountry } from 'store/auth/selectors';
import seasonOverviewFilterReducer, {
  initialSeasonOverviewFilterState,
  SeasonOverviewFilterType,
} from '../store/reducer';

const useSeasonOverviewFilters = () => {
  const userCountry = useSelector(selectUserCountry);

  const [filters, dispatchFilters] = useReducer(seasonOverviewFilterReducer, {
    ...initialSeasonOverviewFilterState,
    country: userCountry,
  });

  const setCountry = (country: string) => {
    dispatchFilters({
      type: SeasonOverviewFilterType.SET_COUNTRY,
      payload: country,
    });
  };

  const setSeasonIndex = (seasonIndex: string | null) => {
    dispatchFilters({
      type: SeasonOverviewFilterType.SET_SEASON_INDEX,
      payload: seasonIndex!,
    });
  };

  return { filters, setCountry, setSeasonIndex };
};

export default useSeasonOverviewFilters;
